<!-- <div class="text-right p-5 mr-10">
  <img [mat-dialog-close] class="close-btn" src="././assets/icon/close_icon.png">
</div> -->
<div class="d-flex justify-content-flex-end cp closebtn" [mat-dialog-close]>
  <img src="././assets/icon/close_icon.png" class="closeHeight">
</div>

<mat-dialog-content >
  <div class="modal-dialog">
   
    <div class="modal-body p-20">
      <ion-row *ngIf="isFirstEmployee">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <label class="formLabelRegularfs16 mb-5 mr-10">This is the First Employee</label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0" *ngFor="let item of employeeData">
          <ion-accordion-group [multiple]="true" [value]="['first','second','third','fourth','fifth','sixth']">
            <ion-accordion value="first" class="mb-10">
              <ion-item slot="header">
                <label class="header-font">Current Employment Related Information</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Employee Code<span class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.empCode}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Employment Category<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="text-font">{{item?.employmentCategory}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Employment Type<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.employmentType}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Retirement Age</div>
                    <div class="text-font">{{item?.retirementAge}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Employee Status<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.empStatus}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Date Of Joining<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.dateOfJoining | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
                    *ngIf="item?.empStatus == 'Exited'">
                    <div class="formLabelRegularfs16 mb-5">Vacant<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.isVacant?'Yes':'No'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
                    *ngIf="item?.empStatus == 'Exited'">
                    <div class="formLabelRegularfs14 mb-5">Date Of Resignation<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="text-font">{{item.dateOfResignation | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
                    *ngIf="item?.empStatus == 'Exited'">
                    <div class="formLabelRegularfs14 mb-5">LWD<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.lastWorkingDate | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Group Name<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.groupName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Company Name<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.companyName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Official Email<span class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.officialEmail}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Reporting Manager Name<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.reportingManager?.firstName}}
                      {{item?.reportingManager?.lastName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Reporting Manager Code<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="text-font">{{item?.reportingManager?.employeeId}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Dotted Reporting Manager Name
                    </div>
                    <div class="text-font">{{item?.dottedReportingManager?.firstName}}
                      {{item?.dottedReportingManager?.lastName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Dotted Reporting Manager Code</div>
                    <div class="text-font">{{item?.dottedReportingManager?.employeeId}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">HOD Name<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.hod?.firstName}} {{item?.hod?.lastName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">HOD Code<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.hod?.employeeId}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Band<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.band}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Grade<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.grade}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Designation<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.designation}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Department/Function<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="text-font">{{item?.department}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Sub Department/Sub Function</div>
                    <div class="text-font">{{item?.subDepartment}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Work Location-State<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.workLocationState}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Work Location- City/ Town<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.workLocationCity}}</div>
                  </ion-col>
                  <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                              <div class="formLabelRegularfs14 mb-5">Catalyst Role</div>
                              <div class="text-font">{{item.catalystRole}}</div>
                            </ion-col> -->
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Designation at DOJ<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.designationAtDoj}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">No. of Promotions/ Upgrades</div>
                    <div class="text-font">{{item?.noOfPromotions}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Current Individual Performance Score</div>
                    <div class="text-font">{{item?.currentPerformanceScore}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Current Individual Performance Rating</div>
                    <div class="text-font">{{item?.currentPerformanceRating}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last Year Individual Performance Score</div>
                    <div class="text-font">{{item?.lastYearPerformanceScore}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last Year Individual Performance Rating</div>
                    <div class="text-font">{{item?.lastYearPerformanceRating}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Year Before Last Year Individual Performance Score</div>
                    <div class="text-font">{{item?.yearBeforeLastYearPerformanceScore}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Year Before Last Year Individual Performance Rating</div>
                    <div class="text-font">{{item?.yearBeforeLastYearPerformanceRating}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
            <ion-accordion value="second" class="mb-10">
              <ion-item slot="header">
                <label class="header-font">General Information</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Salutation<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.salutation}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">First Name<span class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.firstName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last Name<span class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.lastName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Gender<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.gender}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Country<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.country}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Present Address<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.address}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Permanent Address</div>
                    <div class="text-font">{{item?.permanentAddress}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Marital Status</div>
                    <div class="text-font">{{item?.maritalStatus}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
                    *ngIf="item.maritalStatus == 'Married'">
                    <div class="formLabelRegularfs14 mb-5">Date of Marriage</div>
                    <div class="text-font">{{item?.dateOfMarriage | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Date of Birth<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item?.dateOfBirth | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Age</div>
                    <div class="text-font">{{item?.age}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Personal Email</div>
                    <div class="text-font">{{item?.email}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">AdharCard No.<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.aadharNo}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">PAN No.<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.panNo}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">UAN No.</div>
                    <div class="text-font">{{item.uan}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Mobile No (Whats app No.)<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="text-font">{{item.contactNo}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Total Previous Experience Before Joining</div>
                    <div class="text-font">{{item.totalExperience}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Emergency Contact Number</div>
                    <div class="text-font">{{item.emergencyContactNo}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Blood Group</div>
                    <div class="text-font">{{item.bloodGroup}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Father's Name</div>
                    <div class="text-font">{{item.fathersName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Mother's Name</div>
                    <div class="text-font">{{item.mothersName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Spouse's Name</div>
                    <div class="text-font">{{item.spouseName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">No. of Children</div>
                    <div class="text-font">{{item.noOfChildren}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Is Relative Working?</div>
                    <div class="text-font">{{item.isRelativeWorking?'Yes':'No'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
                    *ngIf="item.isRelativeWorking == true">
                    <div class="formLabelRegularfs14 mb-5">Name of Relative Working</div>
                    <div class="text-font">{{item.workingRelativeName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
                    *ngIf="item.isRelativeWorking == true">
                    <div class="formLabelRegularfs14 mb-5">Relation of Relative Working</div>
                    <div class="text-font">{{item.workingRelativeRelation}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
            <ion-accordion value="third" class="mb-10">
              <ion-item slot="header">
                <label class="header-font">Education Related Information</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Education Qualification</div>
                    <div class="text-font">{{item.highestEducationQualification}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Education Institute</div>
                    <div class="text-font">{{item.highestEducationInstitute}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Education Year of Passing</div>
                    <div class="text-font">{{item.highestEducationYearOfPassing}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Education Marks/ %ge</div>
                    <div class="text-font">{{item.highestEducationMarks}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">2nd Highest Education Qualification</div>
                    <div class="text-font">{{item.highestEducationQualification2}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">2nd Highest Education Institute</div>
                    <div class="text-font">{{item.highestEducationInstitute2}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">2nd Highest Education Year of Passing</div>
                    <div class="text-font">{{item.highestEducationYearOfPassing2}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">2nd Highest Education Marks/ %ge</div>
                    <div class="text-font">{{item.highestEducationMarks2}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">3rd Highest Education Qualification</div>
                    <div class="text-font">{{item.highestEducationQualification3}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">3rd Highest Education Institute</div>
                    <div class="text-font">{{item.highestEducationInstitute3}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">3rd Highest Education Year of Passing</div>
                    <div class="text-font">{{item.highestEducationYearOfPassing3}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">3rd Highest Education Marks/ %ge</div>
                    <div class="text-font">{{item.highestEducationMarks3}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Professional Qualification</div>
                    <div class="text-font">{{item.highestProfessionalQualification}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Professional Institute</div>
                    <div class="text-font">{{item.highestProfessionalInstitute}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Professional Year of Passing</div>
                    <div class="text-font">{{item.highestProfessionalYearOfPassing}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Highest Professional Marks/ %ge</div>
                    <div class="text-font">{{item.highestProfessionalMarks}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
            <ion-accordion value="fourth" class="mb-10">
              <ion-item slot="header">
                <label class="header-font">Salary Related</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Currency</div>
                    <div class="text-font">{{item.currency}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Salary Status<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.salaryStatus}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Bank Name<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.bankName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Bank Branch Address<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.bankBranchAddress}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Bank Account No.<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.bankAccount}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">IFSC Code<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.ifscCode}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Basic Salary PM<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.basicSalaryPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Dearness Allowance PM</div>
                    <div class="text-font">{{item.daPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">HRA PM</div>
                    <div class="text-font">{{item.hraPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Other Allowance PM</div>
                    <div class="text-font">{{item.otherAllowancePm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">LTA PM</div>
                    <div class="text-font">{{item.ltaPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Medical Allowance PM</div>
                    <div class="text-font">{{item.medicalAllowancePm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Washing Allowance PM</div>
                    <div class="text-font">{{item.washingAllowancePm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Special Allowance PM</div>
                    <div class="text-font">{{item.specialAllowancePm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Fuel/Petrol Allowance PM</div>
                    <div class="text-font">{{item.fuelAllowancePm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Entertainment Allowance PM</div>
                    <div class="text-font">{{item.entertainmentAllowancePm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Education Allowance PM</div>
                    <div class="text-font">{{item.educationAllowancePm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Books and Periodical Allowance PM</div>
                    <div class="text-font">{{item.booksAllowancePm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Statutory Bonus Allowance PM</div>
                    <div class="text-font">{{item.specialAllowancePm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Allowance PM</div>
                    <div class="text-font">{{item.anyOtherAllowancePm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Gross Salary PM<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.grossSalaryPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Employee PF PM</div>
                    <div class="text-font">{{item.employeePfPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Employer PF PM</div>
                    <div class="text-font">{{item.employerPfPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">PT PM</div>
                    <div class="text-font">{{item.ptPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">LWF PM</div>
                    <div class="text-font">{{item.lwfPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">ESIC PM</div>
                    <div class="text-font">{{item.esicPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Retiral PM</div>
                    <div class="text-font">{{item.otherRetiralPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Total Retiral PM<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.totalRetiralPm}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Fixed CTC Including Retirals PM<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.monthlyCtc}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Fixed CTC Including Retirals PA<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.annualCtc}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Process of Giving VP<span *ngIf="!isFirstEmployee"
                        class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.processOfVp}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Annual Variable Pay Budget</div>
                    <div class="text-font">{{item.annualVariablePayBudget}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Annual Total CTC (fixed CTC + annual variable pay
                      budget)<span *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.annualTotalCtc}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Increment on Fixed Annual CTC or Total Annual CTC<span
                        *ngIf="!isFirstEmployee" class="red-cl">&nbsp;*</span></div>
                    <div class="text-font">{{item.incrementOn}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
            <ion-accordion value="fifth" class="mb-10">
              <ion-item slot="header">
                <label class="header-font">Prior Employment Related</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last Organisation Before Joining</div>
                    <div class="text-font">{{item.lastOrganisationName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last organisation Date Of Joining</div>
                    <div class="text-font">{{item.lastOrganisationDoj | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last organisation Last Working Of Date</div>
                    <div class="text-font">{{item.lastOrganisationLwd | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last organisation Department</div>
                    <div class="text-font">{{item.lastOrganisationDepartment}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last organisation Designation</div>
                    <div class="text-font">{{item.lastOrganisationDesignation}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Before Joining</div>
                    <div class="text-font">{{item.lastToLastOrganisationName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Date Of Joining</div>
                    <div class="text-font">{{item.lastToLastOrganisationDoj | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Last Working Of Date</div>
                    <div class="text-font">{{item.lastToLastOrganisationLwd | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Department</div>
                    <div class="text-font">{{item.lastToLastOrganisationDepartment}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Designation</div>
                    <div class="text-font">{{item.lastToLastOrganisationDesignation}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Organisation Joined Before</div>
                    <div class="text-font">{{item.otherOrganisationName}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Organisation Date Of Joining</div>
                    <div class="text-font">{{item.otherOrganisationDoj | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Organisation Last Working Of Date</div>
                    <div class="text-font">{{item.otherOrganisationLwd | date:'dd-MM-yyyy'}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Organisation Department</div>
                    <div class="text-font">{{item.otherOrganisationDepartment}}</div>
                  </ion-col>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="formLabelRegularfs14 mb-5">Any Other Organisation Designation</div>
                    <div class="text-font">{{item.otherOrganisationDesignation}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
            <ion-accordion value="sixth" class="mb-10">
              <ion-item slot="header">
                <label class="header-font">Additional Field</label>
              </ion-item>
              <div class="p-10" slot="content">
                <ion-row>
                  <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
                    *ngFor="let data of item.customValues">
                    <div class="formLabelRegularfs14 mb-5">{{data.fieldName}}</div>
                    <div class="text-font">{{data.fieldValue}}</div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-col>
      </ion-row>
      <div class="clear50"></div>

      <div class="clear50"></div>
    </div>
  </div>


</mat-dialog-content>